import React from 'react';
import { PhoneIcon } from 'lucide-react';
const btnStyle = {
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 700 as const
};
/**
 * Centered blue "Get a Free Quote" button.
 * Drop after the service-overview split and after "Why Choose Us".
 */
export function CTAButton() {
  return <div className="w-full py-10 px-4" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-645">
      <div className="max-w-7xl mx-auto flex justify-center" data-id="element-646">
        <a href="#quote" className="inline-block w-full sm:w-auto text-center px-10 py-4 rounded-lg text-white text-base transition-all hover:opacity-90 hover:shadow-lg" style={{
        backgroundColor: '#0283C7',
        ...btnStyle
      }} data-id="element-647">
          Get a Free Quote
        </a>
      </div>
    </div>;
}
/**
 * Light-blue variant for sections that sit on #E8F4FD backgrounds.
 */
export function CTAButtonOnBlue() {
  return <div className="w-full py-10 px-4" style={{
    backgroundColor: '#E8F4FD'
  }} data-id="element-648">
      <div className="max-w-7xl mx-auto flex justify-center" data-id="element-649">
        <a href="#quote" className="inline-block w-full sm:w-auto text-center px-10 py-4 rounded-lg text-white text-base transition-all hover:opacity-90 hover:shadow-lg" style={{
        backgroundColor: '#0283C7',
        ...btnStyle
      }} data-id="element-650">
          Get a Free Quote
        </a>
      </div>
    </div>;
}
/**
 * Inline CTA bar — white card with headline + button side-by-side on desktop,
 * stacked on mobile. Drop after the numbered-cards grid.
 */
export function CTABar() {
  return <div className="w-full py-10 px-4" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-651">
      <div className="max-w-4xl mx-auto rounded-2xl px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-6" style={{
      backgroundColor: '#ffffff',
      boxShadow: '0 8px 30px rgba(2,131,199,0.12)',
      border: '1px solid #E8F4FD'
    }} data-id="element-652">
        <h3 className="text-center md:text-left" style={{
        color: '#0283C7',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 800,
        fontSize: 'clamp(18px, 3vw, 22px)',
        lineHeight: 1.3
      }} data-id="element-653">
          Need a quote? We respond same day.
        </h3>
        <a href="#quote" className="inline-block w-full md:w-auto text-center px-10 py-4 rounded-lg text-white text-base flex-shrink-0 transition-all hover:opacity-90 hover:shadow-lg" style={{
        backgroundColor: '#0283C7',
        ...btnStyle
      }} data-id="element-654">
          Get a Free Quote
        </a>
      </div>
    </div>;
}
/**
 * Variant for pages where the numbered cards sit on #E8F4FD.
 */
export function CTABarOnBlue() {
  return <div className="w-full py-10 px-4" style={{
    backgroundColor: '#E8F4FD'
  }} data-id="element-655">
      <div className="max-w-4xl mx-auto rounded-2xl px-8 py-8 flex flex-col md:flex-row items-center justify-between gap-6" style={{
      backgroundColor: '#ffffff',
      boxShadow: '0 8px 30px rgba(2,131,199,0.12)',
      border: '1px solid #E8F4FD'
    }} data-id="element-656">
        <h3 className="text-center md:text-left" style={{
        color: '#0283C7',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 800,
        fontSize: 'clamp(18px, 3vw, 22px)',
        lineHeight: 1.3
      }} data-id="element-657">
          Need a quote? We respond same day.
        </h3>
        <a href="#quote" className="inline-block w-full md:w-auto text-center px-10 py-4 rounded-lg text-white text-base flex-shrink-0 transition-all hover:opacity-90 hover:shadow-lg" style={{
        backgroundColor: '#0283C7',
        ...btnStyle
      }} data-id="element-658">
          Get a Free Quote
        </a>
      </div>
    </div>;
}
/**
 * Full-width blue strip with two buttons.
 * Drop after the "Benefits" section as a mid-page CTA break.
 */
export function MidPageCTAStrip() {
  return <section className="w-full py-14 px-4" style={{
    backgroundColor: '#0283C7'
  }} data-id="element-659">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-8" data-id="element-660">
        <h3 className="text-white" style={{
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 900,
        fontSize: 'clamp(20px, 3.5vw, 28px)',
        lineHeight: 1.3
      }} data-id="element-661">
          Let's get started — free estimates, same-day response.
        </h3>
        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-662">
          <a href="#quote" className="inline-block w-full sm:w-auto text-center px-10 py-4 rounded-lg text-base transition-all hover:opacity-90 hover:shadow-lg" style={{
          backgroundColor: '#ffffff',
          color: '#0283C7',
          ...btnStyle
        }} data-id="element-663">
            Get a Free Quote
          </a>
          <a href="tel:4805998442" className="inline-flex items-center justify-center gap-2 w-full sm:w-auto text-center px-10 py-4 rounded-lg text-base transition-all hover:bg-white/10" style={{
          backgroundColor: 'transparent',
          color: '#ffffff',
          border: '2px solid #ffffff',
          ...btnStyle
        }} data-id="element-664">
            <PhoneIcon className="h-4 w-4" data-id="element-665" />
            Call Now: (480) 599-8442
          </a>
        </div>
      </div>
    </section>;
}